module.exports = __webpack_public_path__ + "static/img/other7.be1bf18.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/other7.png
// module id = BJaO
// module chunks = 1